<template>
  <div v-if="error">
    <code v-if="orderType === 'lead' && params.start_param">
  {{ `${this.$static('m-box.not-found1', 'Заявку #')}${this.params.start_param.split('_')[1]} ${this.$static('m-box.not-found2', 'не знайдено')}` }}
</code>
    <code v-else-if="orderType === 'order' && params.start_param">
  {{ `${this.$static('m-box.not-found3', 'Замовлення №')}${this.params.start_param} ${this.$static('m-box.not-found2', 'не знайдено')}` }}
</code>
    <code v-else>{{ this.$static('m-box.not-found4', 'Інформація відсутня') }}</code>
  </div>
  <template v-else>
    <!--! Если заявка -->
    <template v-if="orderType === 'lead'">
      <div class="container-wrapper manager-personal-area">
        <div class="logged-in panel panel-bordered">
          <div class="logged-in-body logged-in-top">
            <div class="avatar-info">
              <div class="name" v-if="name">{{ name }}</div>
            </div>
            <a :href="`tel:` + phoneValid" class="user-phone" v-if="phoneValid">
              <span class="icon-2 icon-2phone"></span>
              <span class="text">{{ phoneValid }}</span>
            </a>
          </div>
          <div class="logged-order-info" v-if="client">
            <a href="javascript:void(0)" class="default-link">
            </a>
            <div class="logged-in-total">
              <span class="name">{{ this.$static('m-box.orders-total', 'Сума замовлень:') }}</span>
              <span class="value">{{ total }} {{ $store.getters.settings.symbol }}</span>
            </div>
          </div>
        </div>
        <div class="personal_area">
          <div class="personal-area-body" v-if="order">
            <div class="personal-order-list-table">
              <!--personal area order list item-->
              <div class="personal-order-list-item">
                <div class="list-item-top">
                  <div class="date_status order_new">
                    <div class="date_status-body">
                      <span class="date">
                        <span class="order-number">{{ this.$static('m-box.lead-number-title', 'Заявка #') }}{{ order.id
                          }}</span> | {{ new
                            Date(order.created_at).toLocaleDateString(currentLang) }}
                        <span v-if="order.info.orderId" class="order-number">{{ this.$static('m-box.lead-with-order',
                          'З Замовлення #') }}{{ order.info.orderId
                          }}</span>
                      </span>

                      <div class="status-bar">
                        <span class="status">{{ leadStatusList[status] }}</span>
                      </div>
                      <div class="price-element">{{ order.total ? order.total + ' ' + $store.getters.settings.symbol :
                        this.$static('m-box.lead-free', 'Безкоштовно') }}</div>
                      <div class="department-info">

                      </div>
                    </div>
                  </div>
                </div>
                <!-- full information about order-->
                <div class="personal-order-list-item-body">
                  <div class="personal-order-list-item-holder">
                    <div class="personal-order-product-wrapper">
                      <!-- order product item-->
                      <div class="cart-item" v-for="(item, index) in order.info.busked" :key="index">
                        <div class="item-holder">
                          <div class="item-info">
                            <div class="image bg-cover"
                              :style="{ 'background-image': $filters.backgroundImage(item.preview) }"></div>
                            <div class="right-side">
                              <a href="#" class="product-name">{{ item.title }}</a>
                              <div class="additional" v-if="item.add?.length">
                                <div class="additional-line" v-for="(o, s_index) in item.add" :key="s_index">
                                  <div class="add-name">{{ o.name }}:</div>
                                  <div class="value" v-if="o.price">{{ o.price }} {{ $store.getters.settings.symbol }}
                                  </div>
                                </div>
                              </div>
                              <div class="additional" v-if="item.u_select?.length">
                                <div class="additional-line" v-for="(o, s_index) in item.u_select" :key="s_index">
                                  <div class="add-name">{{ o.item.name }}:</div>
                                  <div class="value" v-if="o.item.price">{{ o.item.price }} {{
                                    $store.getters.settings.symbol }}
                                  </div>
                                </div>
                              </div>

                            </div>
                          </div>
                          <div class="option-box">
                            <div class="item">
                              <div class="item-name">{{ this.$static('m-box.lead-price', 'Ціна:') }}</div>
                              <div class="value">{{ item.price ? item.price + ' ' + $store.getters.settings.symbol :
                                this.$static('m-box.lead-free', 'Безкоштовно') }}</div>
                            </div>
                            <div class="item text-right">
                              <div class="item-name">{{ this.$static('m-box.lead-sum', 'Сума:') }}</div>
                              <div class="value">
                                {{ item.count && itemTotal(item) / item.count ? item.count + ' x ' + (itemTotal(item) /
                                  item.count) + ' ' + $store.getters.settings.symbol : 'Безкоштовно' }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- end order product item-->
                      <!-- order list item actions-->
                    </div>
                  </div>

                  <div class="personal-order-list-item-footer ">
                    <div class="panel-bordered footer-holder">
                      <div class="left-item-footer">
                        <div class="order-related-info">
                          <ul>
                            <li v-if="order.info.name">
                              <div class="name">{{ this.$static('m-box.name', 'Ім\'я') }}</div>
                              <div class="value">{{ order.info.name }}</div>
                            </li>

                            <li v-if="order.info.phone">
                              <div class="name">{{ this.$static('m-box.phone', 'Телефон') }}</div>
                              <div class="value">{{ order.info.phone }}</div>
                            </li>

                            <li v-if="order.info.email">
                              <div class="name">Email</div>
                              <div class="value">{{ order.info.email }}</div>
                            </li>

                            <li v-if="order.info.date">
                              <div class="name">{{ this.$static('m-box.date', 'Обрана дата') }}</div>
                              <div class="value">{{
                                new Date(order.info.date * 1000).toLocaleDateString(currentLang) }}</div>
                            </li>
                            <template v-if="order.info.fields && order.info.fields.length > 0">

                              <li v-for="(field, fieldIndex) in order.info.fields" :key="fieldIndex">
                                <template
                                  v-if="field.manifest.type === 'file' && Array.isArray(field.data) && field.data?.length > 0">
                                  <label class="custom-label">{{ field.manifest.name || `Додаткове поле
                                    №${fieldIndex + 1}`
                                    }}</label>

                                  <div class="files-uploader default-files-uploader">
                                    <div class="uploader-previews">

                                      <div class="image bg" width="40px" height="40px"
                                        v-for="(requestImg, requestImgIndex) in field.data"
                                        :key="'requstImg' + requestImgIndex" :style="{
                                          backgroundImage: isImageFile(requestImg) ? `url('${requestImg}')` : `url('/images/file_placeholder.png')`
                                        }">
                                        <div>
                                          <Popper v-if="isImageFile(requestImg)" arrow content="Відкрити" hover
                                            placement="top" style="white-space: nowrap">
                                            <a width="5px" height="5px" data-fancybox="gallery"
                                              class="btn-icon btn-remove btn-small" :href="requestImg"
                                              style="bottom: 3px;top: inherit;left: 3px;">
                                              <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path d="M5 7.5L10 12.5L15 7.5" stroke="#212121" />
                                              </svg>
                                            </a>
                                          </Popper>

                                          <Popper v-if="!isImageFile(requestImg)" arrow content="Завантажити" hover
                                            placement="top" style="white-space: nowrap">
                                            <button class="btn-icon btn-remove btn-small"
                                              @click="downloadServiceRequestFile(requestImg)"
                                              style="bottom: 3px;top: inherit;right: 3px;">
                                              <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path d="M5 7.5L10 12.5L15 7.5" stroke="#212121" />
                                              </svg>
                                            </button>
                                          </Popper>
                                        </div>

                                      </div>
                                    </div>
                                  </div>
                                </template>

                                <template v-else-if="typeof field.data === 'number' || field.data?.length > 0">
                                  <div class="name">{{ field.manifest.name }}</div>
                                  <div class="value">{{ field.data }}</div>
                                </template>
                              </li>
                            </template>

                            <template v-if="order.info.orderPageComment">
                              <li>
                                <div class="name">{{ this.$static('m-box.comment', 'Коментар') }}</div>
                                <div class="value">{{ order.info.orderPageComment }}</div>
                              </li>
                            </template>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- end full information about order-->
              </div>
              <!--end personal area order list item-->
            </div>
          </div>
        </div>
        <div class="bottom-nav" v-if="status !== 'complete' || 'cancel'">
          <div class="holder">
            <div class="button-holder" v-for="(btn, index) in leadButtons" :key="index">
              <a href="javascript:void(0)" @click.prevent="setStatus(btn)" class="default-btn" :class="btn.class">
                {{ btn.label }}
              </a>
            </div>
          </div>
        </div>
      </div>

      <a href="#status_confirm" id="status_confirm_button" data-toggle="modal"></a>
      <div class="modal custom-modal fade" id="status_confirm" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered d-flex align-items-center" style="height:90%" role="document">
          <div class="modal-content w-100">
            <div class="modal-header">
              <!--          <button type="button" class="close" data-dismiss="modal" aria-label="Close">-->
              <!--            <span class="icon icon-cross"></span>-->
              <!--          </button>-->
            </div>
            <div class="modal-body" v-if="button">
              <h2 style="text-align: center">{{ this.$static('m-box.change-status-approve', 'Підтвердіть зміну статуса')
                }}
              </h2>
              <div class="form-group" v-if="button.message_text !== undefined">
                <div class="custom-label">{{ this.$static('m-box.message-to-client', 'Повідомлення клієнту') }}</div>
                <input class="form-control custom-input" v-model="button.message_text" />
              </div>

              <div class="button-holder">
                <a href="javascript:void(0)" @click.prevent="confirmLead_noDelete" style="width: 100%"
                  class="default-btn btn-green" data-dismiss="modal" aria-label="Close">
                  {{ this.$static('m-box.approve', 'Підтвердити') }}
                </a>
              </div>

              <div class="button-holder" v-if="button.delete_last" style="margin-top: 15px">
                <a href="javascript:void(0)" @click="confirmLead" style="width: 100%" class="default-btn btn-remove"
                  data-dismiss="modal" aria-label="Close">
                  {{ this.$static('m-box.approve-and-remove', 'Підтвердити і видалити з чату') }}
                </a>
              </div>

            </div>
          </div>
        </div>
      </div>

      <a href="#status_confirmed" id="status_confirmed_button" data-toggle="modal"></a>
      <div class="modal custom-modal fade" id="status_confirmed" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <!--          <button type="button" class="close" data-dismiss="modal" aria-label="Close">-->
              <!--            <span class="icon icon-cross"></span>-->
              <!--          </button>-->
            </div>
            <div class="modal-body" v-if="button">
              <h2 style="text-align: center">{{ this.$static('m-box.approve-status', 'Статус підтвердженно') }}</h2>
              <div class="button-holder">
                <a href="javascript:void(0)" @click="closeTelegram" style="width: 100%" class="default-btn btn-green"
                  data-dismiss="modal" aria-label="Close">
                  {{ this.$static('m-box.ok', 'ОК') }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <!--! Если заказ -->
    <template v-else-if="orderType === 'order'">
      <div class="container-wrapper manager-personal-area">
        <div class="logged-in panel panel-bordered">
          <div class="logged-in-body logged-in-top">
            <div class="avatar-info">
              <div class="name" v-if="name">{{ name }}</div>
              <div class="bonus-panel" v-if="client">
                <span>{{ this.$static('m-box.bonuses-title', 'Бонуси: ') }} <span class="num">{{ bonus
                    }}</span></span>
              </div>
            </div>
            <a :href="`tel:` + phoneValid" class="user-phone" v-if="phoneValid">
              <span class="icon-2 icon-2phone"></span>
              <span class="text">{{ phoneValid }}</span>
            </a>
          </div>
          <div class="logged-order-info" v-if="client">
            <a href="javascript:void(0)" class="default-link">
              <!--          <span class="text">Історія замовлень</span>-->
              <!--          <span class="icon icon-right"></span>-->
            </a>
            <div class="logged-in-total">
              <span class="name">{{ this.$static('m-box.orders-total', 'Сума замовлень: ') }}</span>
              <span class="value">{{ total }} {{ $store.getters.settings.symbol }}</span>
            </div>
          </div>
          <!-- <div class="logged-in-bottom">

          </div> -->
        </div>
        <div class="personal_area">
          <div class="personal-area-body" v-if="order">
            <div class="personal-order-list-table">
              <!--personal area order list item-->
              <div class="personal-order-list-item">
                <div class="list-item-top">
                  <div class="date_status order_new">
                    <div class="date_status-body">
                      <span class="date">
                        <span class="order-number">{{ this.$static('m-box.order-number', 'Замовлення #') }}{{ order.id
                          }}</span> | {{ new
                            Date(order.created_at).toLocaleDateString(currentLang) }}
                      </span>
                      <div class="status-bar">
                        <span class="status">{{ statusList[status] }} | {{ payStatusList[pay_status] }}</span>
                      </div>
                      <div class="price-element">{{ order.total }} {{ $store.getters.settings.symbol }}</div>
                      <div class="department-info">
                        <!-- <div class="department-info-box">
                      <div class="department-info-name">Пункт видачі:</div>
                      <span class="department-address" v-if="storehouse">{{ storehouse.name }}</span>
                    </div> -->
                        <div class="department-info-box" v-if="order.info.delivery.manifest.title">
                          <div class="department-info-name">{{ this.$static('m-box.delivery-type', 'Тип доставки:') }}
                          </div>
                          <span class="department-address">{{ order.info.delivery.manifest.title }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="price-box">
                    <div class="price-element">{{ totalBusked }} {{ $store.getters.settings.symbol }}</div>
                  </div>
                </div>
                <!-- full information about order-->
                <div class="personal-order-list-item-body">
                  <div class="personal-order-list-item-holder">
                    <div class="personal-order-product-wrapper">
                      <!-- order product item-->
                      <div class="cart-item" v-for="(item, index) in order.info.busked" :key="index">
                        <div class="item-holder">
                          <div class="item-info">
                            <div class="image bg-cover"
                              :style="{ 'background-image': $filters.backgroundImage(item.preview) }"></div>
                            <div class="right-side">
                              <a href="#" class="product-name">{{ item.title }}</a>
                              <div class="additional" v-if="item.add?.length">
                                <div class="additional-line" v-for="(o, s_index) in item.add" :key="s_index">
                                  <div class="add-name">{{ o.name }}:</div>
                                  <div class="value" v-if="o.price">{{ o.price }} {{ $store.getters.settings.symbol }}
                                  </div>
                                </div>
                              </div>
                              <div class="additional" v-if="item.u_select?.length">
                                <div class="additional-line" v-for="(o, s_index) in item.u_select" :key="s_index">
                                  <div class="add-name">{{ o.item.name }}:</div>
                                  <div class="value" v-if="o.item.price">{{ o.item.price }}
                                    {{ $store.getters.settings.symbol }}
                                  </div>
                                </div>
                              </div>

                            </div>
                          </div>
                          <div class="option-box">
                            <div class="item">
                              <div class="item-name">{{ this.$static('m-box.price', 'Ціна:') }}</div>
                              <div class="value">{{ item.price }} {{ $store.getters.settings.symbol }}</div>
                            </div>
                            <div class="item text-right">
                              <div class="item-name">{{ this.$static('m-box.sum', 'Сума:') }}</div>
                              <div class="value">{{ item.count }} x {{ itemTotal(item) / item.count }} {{
                                $store.getters.settings.symbol }}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- end order product item-->
                      <!-- order list item actions-->
                      <div class="personal-order-list-item-bottom">
                        <div class="lines">
                          <div class="line promocode">
                            <div class="name">{{ this.$static('m-box.promocode-title', 'Промокод:') }}</div>
                            <div class="value" v-if="order.info.promo">{{ order.info.promo }}</div>
                            <div class="value" v-else>----</div>
                          </div>
                          <div class="line bonus">
                            <div class="name">{{ this.$static('m-box.bonuses-counted', 'Нараховано бонусів:') }}</div>
                            <div class="value" v-if="order.info.bonus">{{ order.info.bonus }}</div>
                            <div class="value" v-else>0</div>
                          </div>
                        </div>
                      </div>
                      <!--end  order list item actions-->
                      <div class="comment-curier-area" v-if="order?.info?.comment">
                        <div class="label-custom">{{ this.$static('m-box.comment', 'Коментар') }}</div>
                        <div class="text">{{ order.info.comment }}</div>
                      </div>
                    </div>
                  </div>

                  <div class="personal-order-list-item-footer ">
                    <div class="panel panel-bordered footer-holder">
                      <div class="left-item-footer">
                        <div class="order-related-info">
                          <ul>
                            <li v-if="pay_type?.manifest">
                              <div class="name">{{ this.$static('m-box.payment-type-title', 'Тип оплати:') }}</div>
                              <div class="value">{{ pay_type.manifest.title }}</div>
                            </li>

                            <li>
                              <div class="name">{{ this.$static('m-box.delivery-type', 'Тип доставки:') }}</div>
                              <div class="value">{{ order.info.delivery.manifest.title }}</div>
                            </li>

                            <li v-if="order.info.delivery.city">
                              <div class="name">{{ this.$static('m-box.delivery-city', 'Місто') }}</div>
                              <div class="value">{{ order.info.delivery.city }}</div>
                            </li>

                            <li v-if="order.info.delivery.zip">
                              <div class="name">{{ this.$static('m-box.delivery-zip', 'Індекс') }}</div>
                              <div class="value">{{ order.info.delivery.zip }}</div>
                            </li>

                            <li v-if="order.info.delivery.warehouse">
                              <div class="name">{{ this.$static('m-box.delivery-department', 'Віділення') }}</div>
                              <div class="value">{{ order.info.delivery.warehouse }}</div>
                            </li>

                            <li v-if="order.info.delivery.address">
                              <div class="name">{{ this.$static('m-box.delivery-address', 'Адреса') }}</div>
                              <div class="value">{{ order.info.delivery.address }}</div>
                            </li>

                            <li v-if="order.info.delivery.b_number">
                              <div class="name">{{ this.$static('m-box.delivery-building', 'Будинок') }}</div>
                              <div class="value">{{ order.info.delivery.b_number }}</div>
                            </li>
                            <li v-if="order.info.delivery.floor">
                              <div class="name">{{ this.$static('m-box.delivery-floor', 'Поверх') }}</div>
                              <div class="value">{{ order.info.delivery.floor }}</div>
                            </li>

                            <li v-if="order.info.delivery.apartment">
                              <div class="name">{{ this.$static('m-box.delivery-flat', '№ квартири:') }}</div>
                              <div class="value">{{ order.info.delivery.apartment }}</div>
                            </li>

                          </ul>
                        </div>

                      </div>
                      <div class="right-item-footer">
                        <div class="billing-info">
                          <ul>
                            <li>
                              <div class="name">{{ this.$static('m-box.order-title', 'Замовлення') }}</div>
                              <div class="value">{{ totalBusked }}{{ $store.getters.settings.symbol }}</div>
                            </li>
                            <li v-if="order.info.promo_discount">
                              <div class="name">{{ this.$static('m-box.promocode-discounte', 'Знижка по промокоду') }}
                              </div>
                              <div class="value">{{ order.info.promo_discount }} {{ $store.getters.settings.symbol }}
                              </div>
                            </li>
                            <li v-if="order.info.bonus_discount">
                              <div class="name">{{ this.$static('m-box.spent-bonuses', 'Використані бонусів') }}</div>
                              <div class="value">{{ order.info.bonus_discount }} {{ $store.getters.settings.symbol }}
                              </div>
                            </li>
                            <li v-if="order.info.delivery_price">
                              <div class="name">{{ this.$static('m-box.delivery-price', 'Ціна доставки') }}</div>
                              <div class="value">{{ order.info.delivery_price }} {{ $store.getters.settings.symbol }}
                              </div>
                            </li>
                            <li class="total">
                              <div class="name">{{ this.$static('m-box.total', 'ВСЬОГО:') }}</div>
                              <div class="value">
                                <div class="price-element">{{ order.total }} {{ $store.getters.settings.symbol }}</div>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- end full information about order-->
              </div>
              <!--end personal area order list item-->
            </div>
          </div>
        </div>
        <div class="bottom-nav">
          <div class="holder">
            <div class="button-holder" v-for="(btn, index) in buttons" :key="index">
              <a href="javascript:void(0)" @click="setStatus(btn)" class="default-btn" :class="btn.class">
                {{ btn.label }}
              </a>
            </div>
          </div>
        </div>
      </div>

      <a href="#status_confirm" id="status_confirm_button" data-toggle="modal"></a>
      <div class="modal custom-modal fade" id="status_confirm" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered d-flex align-items-center" style="height:90%" role="document">
          <div class="modal-content w-100">
            <div class="modal-header">
              <!--          <button type="button" class="close" data-dismiss="modal" aria-label="Close">-->
              <!--            <span class="icon icon-cross"></span>-->
              <!--          </button>-->
            </div>
            <div class="modal-body" v-if="button">
              <h2 style="text-align: center">{{ this.$static('m-box.change-status-approve', 'Підтвердіть зміну статуса')
                }}</h2>
              <div class="form-group" v-if="button.message_text !== undefined">
                <div class="custom-label">{{ this.$static('m-box.message-to-client', 'Повідомлення клієнту') }}</div>
                <input class="form-control custom-input" v-model="button.message_text" />
              </div>

              <div class="button-holder">
                <a href="javascript:void(0)" @click="confirm_noDelete" style="width: 100%" class="default-btn btn-green"
                  data-dismiss="modal" aria-label="Close">
                  {{ this.$static('m-box.approve', 'Підтвердити') }}
                </a>
              </div>

              <div class="button-holder" v-if="button.delete_last" style="margin-top: 15px">
                <a href="javascript:void(0)" @click="confirm" style="width: 100%" class="default-btn btn-remove"
                  data-dismiss="modal" aria-label="Close">
                  {{ this.$static('m-box.approve-and-remove', 'Підтвердити і видалити з чату') }}
                </a>
              </div>

            </div>
          </div>
        </div>
      </div>

      <a href="#status_confirmed" id="status_confirmed_button" data-toggle="modal"></a>
      <div class="modal custom-modal fade" id="status_confirmed" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <!--          <button type="button" class="close" data-dismiss="modal" aria-label="Close">-->
              <!--            <span class="icon icon-cross"></span>-->
              <!--          </button>-->
            </div>
            <div class="modal-body" v-if="button">
              <h2 style="text-align: center">{{ this.$static('m-box.approve-status', 'Статус підтвердженно') }}</h2>
              <div class="button-holder">
                <a href="javascript:void(0)" @click="closeTelegram" style="width: 100%" class="default-btn btn-green"
                  data-dismiss="modal" aria-label="Close">
                  {{ this.$static('m-box.ok', 'ОК') }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </template>
</template>

<script>
// @ is an alias to /src



export default {
  name: 'ManagerBox',
  data() {
    return {
      orderType: undefined,
      error: undefined,
      button: undefined,
      load: false,
      open: false,
      order: undefined,
      client: undefined,

      payment: [],
      statusList: {},
      leadStatusList: {},
      payStatusList: {},
      params: undefined,
      initData: undefined
    }
  },
  computed: {
    buttons() {
      if (this.status === 'new') {
        return [
          {
            'label': 'Відмінити',
            'class': 'btn-red',
            'message_text': 'Вибачте не можемо виконати ваше замовлення.',
            'status': 'cancel'
          },
          {
            'label': 'Прийняти',
            'class': 'btn-green',
            'status': 'process'
          }
        ]
      } else if (this.status === 'process') {
        return [
          {
            'label': 'Відмінити',
            'class': 'btn-red',
            'status': 'cancel',
            'message_text': 'Вибачте кухня відмінила ваше замовлення.',
            'delete_last': true
          },
          {
            'label': 'Передати курьеру',
            'class': 'btn-green',
            'status': 'progress',
            'delete_last': true
          }
        ]
      } else if (this.status === 'progress') {
        return [
          {
            'label': 'Доставлено',
            'class': 'btn-green',
            'status': 'delivery',
            'delete_last': true,
            'pay': true
          }
        ]
      }
      if (!this.status || ['cancel', 'back', 'delivery'].some(status => status === this.status)) {
        return []
      }
      return [
        {
          'label': 'Відмінити',
          'class': 'btn-red',
          'status': 'cancel'
        },
        {
          'label': 'Завершити',
          'class': 'btn-green',
          'status': 'delivery'
        }
      ]
    },

    leadButtons() {
      if (this.status === 'new') {
        return [
          {
            'label': 'Відмінити',
            'class': 'btn-red',
            'message_text': 'Вибачте не можемо виконати вашу заявку.',
            'status': 'cancel'
          },
          {
            'label': 'Прийняти',
            'class': 'btn-green',
            'status': 'process'
          }
        ]
      } else if (this.status === 'process') {
        return [
          {
            'label': 'Відмінити',
            'class': 'btn-red',
            'status': 'cancel',
            'message_text': 'Вибачте не можемо виконати вашу заявку.',
            'delete_last': true
          },
          {
            'label': 'Завершити',
            'class': 'btn-green',
            'status': 'complete',
            'delete_last': true
          }
        ]
      }
      if (!this.status || ['cancel', 'complete'].some(status => status === this.status)) {
        return []
      }
      return [
        {
          'label': 'Відмінити',
          'class': 'btn-red',
          'status': 'cancel'
        },
        {
          'label': 'Завершити',
          'class': 'btn-green',
          'status': 'complete'
        }
      ]
    },

    name() {
      return (this.order?.info?.name ? this.order.info.name + ' ' : '') + this.surname
    },
    totalBusked() {
      return this.order?.info?.busked?.reduce((prev, next) => this.itemTotal(next) + prev, 0)
    },
    noCall() {
      return this.order?.info?.no_call
    },
    leave() {
      return this.order?.info?.leave
    },
    surname() {
      return this.order?.info?.surname ? this.order.info.surname : ''
    },
    phone() {
      return this.order?.info?.phone ? this.order.info.phone.match(/\d+/g).join('') : ''
    },
    phoneValid() {
      return this.phone.startsWith('+') ? this.phone : '+' + this.phone
    },
    total() {
      return 0 + this.client.total
    },
    bonus() {
      return 0 + this.client?.bonus
    },
    pay_type() {
      return this.order?.info?.pay_type ? this.payment.find(pay => pay.id === this.order.info.pay_type) : undefined
    },
    delivery() {
      return this.order?.delivery
    },
    status() {
      return this.order?.status
    },
    pay_status() {
      return this.order?.pay_status
    },
    href() {
      return window.location.href
    },
    currentLang() {
      const currentLang = localStorage.getItem('$lang');

      if (currentLang && currentLang !== "" && currentLang !== "ua") {
        return currentLang
      }
      return "uk"
    },
  },
  mounted() {
    let statuses = [
      { label: this.$static('slist.new', 'Новий'), value: 'new' },
      { label: this.$static('slist.process', 'Підтверджено'), value: 'process' },
      { label: this.$static('slist.progress', 'Відправлено'), value: 'progress' },
      { label: this.$static('slist.delivery', 'Отримано'), value: 'delivery' },
      { label: this.$static('slist.back', 'Повернення'), value: 'back' },
      { label: this.$static('slist.cancel', 'Відміна'), value: 'cancel' }
    ];
    statuses.forEach(status => {
      this.statusList[status.value] = status.label;
      this.payStatusList[status.value] = status.label;
    });

    let leadStatuses = [
      { label: this.$static('lead-slist.new', 'Нові'), value: 'new' },
      { label: this.$static('lead-slist.process', 'В обробці'), value: 'process' },
      { label: this.$static('lead-slist.complete', 'Завершені'), value: 'complete' },
      { label: this.$static('lead-slist.cancel', 'Відмінені'), value: 'cancel' }
    ];
    leadStatuses.forEach(leadStatus => {
      this.leadStatusList[leadStatus.value] = leadStatus.label;
      this.payStatusList[leadStatus.value] = leadStatus.label;
    });

    let payStatuses = [
      { label: this.$static('pstatus.npay', 'Очікує сплати'), value: 'npay' },
      { label: this.$static('pstatus.pay', 'Сплачено'), value: 'pay' },
      { label: this.$static('pstatus.cpay', 'Відміна'), value: 'cpay' }
    ];
    payStatuses.forEach(status => {
      this.payStatusList[status.value] = status.label;
    })

    this.fetchSettings();
    fetch('/public/plugin').then(response => response.json()).then(data => {
      data.forEach(x => {
        this[x.type] = x.list;
      });
    });

    let tgScript = window.document.querySelector('#telegram_script');
    if (tgScript) {
      this.getOrder();
    } else {
      let tgScript = document.createElement('script');
      tgScript.setAttribute('src', 'https://telegram.org/js/telegram-web-app.js');
      tgScript.setAttribute('id', 'telegram_script');
      tgScript.onload = () => {
        this.getOrder();
      }
      document.head.appendChild(tgScript);
    }
  },
  methods: {
    itemTotal(item) {
      return (item.price + this.addPrice(item) + this.uAddPrice(item)) * item.count
    },

    addPrice(item) {
      if (!item.add || !Array.isArray(item.add)) {
        return 0; // Возвращаем 0, если item.add отсутствует или не является массивом
      }

      return item.add.reduce((prev, next) => {
        return next && next.price ? next.price + prev : prev;
      }, 0);
    },

    uAddPrice(item) {
      if (!item.u_select || !Array.isArray(item.u_select)) {
        return 0; // Возвращаем 0, если item.u_select отсутствует или не является массивом
      }

      return item.u_select.reduce((prev, next) => {
        return next?.item?.price ? next.item.price + prev : prev;
      }, 0);
    },

    closeTelegram() {
      return window.Telegram.WebApp.close()
    },

    openPhone() {
      window.Telegram.WebApp.openLink('tel:' + this.phoneValid);
    },

    async getOrder() {
      if (window.Telegram?.WebApp?.initDataUnsafe?.start_param) {
        this.params = window.Telegram.WebApp.initDataUnsafe;
        this.initData = window.Telegram.WebApp.initData;
      }
      // Убрать для прода
      if (this.params?.start_param && typeof this.params.start_param === 'string' && this.params.start_param.includes("lead_")) {
        this.orderType = "lead";
      } else {
        this.orderType = "order";
      }

      // Вернуть, как было
      let params = { start_param: this.params.start_param, initData: this.initData };
      // let params = { start_param: 337, initData: this.initData }; // Временная строка параметров
      // let params = { start_param: "lead_97", initData: this.initData };

      try {
        const response = await fetch(`/public/manager/order`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json;charset=utf-8'
          },
          body: JSON.stringify(params)
        });

        const data = await response.json();

        if (data.error) {
          this.error = data.error;
        }

        if (data.result) {
          this.order = data.result;
          this.client = data.client;
        }
      } catch (error) {
        console.error('Error fetching order:', error);
      }
    },

    async fetchSettings() {
      try {
        const response = await fetch('/public/settings');
        const data = await response.json();

        if (data) {
          this.$store.commit('setSettings', data);
        }
      } catch (error) {
        console.error('Error fetching settings:', error);
      }
    },

    async getOptions() {
      try {
        const response = await fetch('/public/options');
        const data = await response.json();

        data.result.forEach(o => {
          /*eslint no-case-declarations: "off"*/
          switch (o.option_id) {
            case 'tags':
              this.$store.commit('setTags', o.list);
              break;
            case 'category':
              this.$store.commit('setCategories', o.list);
              break;
            default:
              this.$store.commit('setOptions', o);
              break;
          }
        });
      } catch (error) {
        console.error('Error fetching options:', error);
      }
    },

    setStatus(button) {
      this.button = button
      window.$('#status_confirm_button').click()
    },

    confirm_noDelete() {
      delete this.button.delete_last;
      this.confirm()
    },
    confirmLead_noDelete() {
      delete this.button.delete_last;
      this.confirmLead()
    },
    async confirm() {
      if (this.load) {
        return;
      }

      this.load = true;

      let body = {
        update: this.button,
        start_param: this.params.start_param,
        initData: this.initData
      };

      // let body = { update: this.button, start_param: "lead_97", initData: null }; // <!--? временная строка параметров

      try {
        const response = await fetch(`/public/manager/set_status`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json;charset=utf-8'
          },
          body: JSON.stringify(body)
        });

        const json = await response.json();

        window.$('#status_confirmed_button').click();
        this.load = false;

        if (json.result) {
          this.order = json.result;
        }

        if (json.client) {
          this.client = json.client;
        }

        setTimeout(() => {
          this.closeTelegram();
        }, 2000);
      } catch (error) {
        console.error('Error setting status:', error);
        this.load = false;
      }
    },
    async confirmLead() {
      if (this.load) {
        return;
      }

      this.load = true;

      let body = {
        update: this.button,
        start_param: this.params.start_param,
        initData: this.initData
      };

      // let body = { update: this.button, start_param: 215, initData: null }; // <!--? временная строка параметров

      try {
        const response = await fetch(`/public/manager/set_status_lead`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json;charset=utf-8'
          },
          body: JSON.stringify(body)
        });

        const json = await response.json();

        window.$('#status_confirmed_button').click();
        this.load = false;

        if (json.result) {
          this.order = json.result;
        }

        if (json.client) {
          this.client = json.client;
        }

        setTimeout(() => {
          this.closeTelegram();
        }, 2000);
      } catch (error) {
        console.error('Error setting status:', error);
        this.load = false;
      }
    },
    isImageFile(filename) {
      if (typeof filename !== 'string') {
        return false;
      }
      const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp', 'tiff', 'jfif'];
      const extension = filename.split('.').pop().toLowerCase();
      return imageExtensions.includes(extension);
    }
  }
}
</script>

<style scoped>
@media (min-width : 768px) {
  .frame-modal-wrapper.order-address-select .address-list::-webkit-scrollbar {
    width: 3px;
  }

  .frame-modal-wrapper.order-address-select {
    transform: none;
    width: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-align-items: center;
    align-items: center;
    justify-content: center;
    -moz-justify-content: center;
    -webkit-justify-content: center;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1111;
    height: 100%;
  }

  .frame-modal-wrapper.order-address-select .frame-modal-body {
    padding: 20px;
  }

  .frame-modal-wrapper.order-address-select .modal-wrapper-holder {
    height: 650px;
    width: 500px;
    display: block;
    border-radius: 20px;
  }
}

@media (min-width : 1200px) {

  .frame-modal-wrapper.order-address-select .address-list li a:hover {
    background-color: #f9f9f9;
  }
}

.manager-personal-area .bottom-nav {
  background-color: #fff;
  padding: 10px 0;
  box-shadow: -2px -2px 4px rgba(0, 0, 0, 0.15);
}

.manager-personal-area .bottom-nav .default-btn.btn-red {
  background-color: #df4040;
  color: #fff;
}

.manager-personal-area .bottom-nav .button-holder {
  margin-right: 15px;
}

.manager-personal-area .bottom-nav .holder {
  margin: auto;
  width: 100%;
  max-width: 1000px;
  display: flex;
}

.frame-modal-wrapper.order-address-select.opened {
  opacity: 1;
  visibility: visible;
}

.frame-modal-wrapper.order-address-select {
  transition: all .05s cubic-bezier(.165, .84, .44, 1);
  -webkit-transition: all .05s cubic-bezier(.165, .84, .44, 1);
  opacity: 0;
  visibility: hidden;
}

.frame-modal-wrapper.order-address-select .frame-modal-header {
  border-bottom: 1px solid #c8cfd9;
  position: relative;
  padding: 15px;
}

.frame-modal-wrapper.order-address-select .frame-modal-header .close-frame {
  position: absolute;
  right: 20px;
  top: 20px;
}

.frame-modal-wrapper.order-address-select .frame-modal-header .name {
  margin-bottom: 0;
}

.frame-modal-wrapper.order-address-select .modal-wrapper-holder {
  background-color: #fff;
}

.frame-modal-wrapper.order-address-select .address-list {
  margin-top: 15px;
  overflow-y: auto;
  height: 450px;
}

.frame-modal-wrapper.order-address-select .address-list li {
  margin-bottom: 0;
}

.frame-modal-wrapper.order-address-select .address-list li a {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  height: 60px;
  position: relative;
  border-radius: 9px;
}

.frame-modal-wrapper.order-address-select .address-list li a img {
  position: absolute;
  top: 50%;
  left: 9px;
  transform: translate(0, -50%);
  -webkit-transform: translate(0, -50%);
}

.frame-modal-wrapper.order-address-select .address-list li a span.subtitle {
  opacity: 0.6;
  font-size: 80%;
}

.frame-modal-wrapper.order-address-select .address-list li a span.address-text {
  display: block;
  position: relative;
  width: 100%;
  padding-left: 40px;
}

.frame-modal-wrapper.order-address-select .address-list li a span.address-name,
.frame-modal-wrapper.order-address-select .address-list li a span.subtitle {
  display: -webkit-box;
  width: 95%;
  text-overflow: ellipsis;
  line-clamp: 1;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.frame-modal-wrapper.order-address-select .search-input {
  position: relative;
}

.frame-modal-wrapper.order-address-select .search-input img {
  width: 30px;
  position: absolute;
  z-index: 3;
  left: 5px;
  top: 10px;
}

.frame-modal-wrapper.order-address-select .search-input .form-control.custom-input {
  padding-left: 40px;
}

.department-map {
  padding: 20px;
}

.order-related-info li {
  margin-bottom: 4px;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: justify !important;
  -webkit-justify-content: space-between !important;
  -ms-flex-pack: justify !important;
  justify-content: space-between !important;
}

.bg-cover {
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
}

.personal_area {

  padding-bottom: 50px;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  position: relative;
}

.personal_area .personal-area-body {
  position: relative;
  width: 100%;
  padding-top: 20px;
  max-width: 1000px;
  margin: auto;
}

.personal_area .personal-order-list-table .personal-order-list-item {
  position: relative;
  margin-bottom: 15px;
  border-radius: 16px;
  -webkit-border-radius: 16px;
  -moz-border-radius: 16px;
  background-color: #ffffff;
  border: 1px solid #c8cfd9;
}

.personal_area .personal-order-list-table .personal-order-list-item .show-in-map {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  z-index: 3;
  font-size: 11px;
  padding: 0 10px;
  line-height: 19px;
  border-radius: 4px;
  background-color: #f0f0f0;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.12);
  position: absolute;
  left: 295px;
  top: 44px;
}

.personal_area .personal-order-list-table .personal-order-list-item .show-in-map .text {
  display: inline-block;
}

.personal_area .personal-order-list-table .personal-order-list-item .cart-item {
  border-radius: 11px;
  border: 1px solid #c8cfd9;
  background-color: #ffffff;
  margin-bottom: 10px;
  padding: 10px;
}

.personal_area .personal-order-list-table .personal-order-list-item .cart-item .additional {
  margin-top: 10px;
}

.personal_area .personal-order-list-table .personal-order-list-item .cart-item .additional .additional-line {
  position: relative;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: flex-end;
  align-items: flex-end;
  margin-bottom: 4px;
  -webkit-box-pack: justify !important;
  -webkit-justify-content: space-between !important;
  -ms-flex-pack: justify !important;
  justify-content: space-between !important;
  color: #9093AD;
  font-size: 12px;
}

.personal_area .personal-order-list-table .personal-order-list-item .cart-item .additional .additional-line .value {
  padding-left: 5px;
  white-space: nowrap;
}

.personal_area .personal-order-list-table .personal-order-list-item .cart-item .additional .additional-line .add-name {
  padding-right: 5px;
}

.personal_area .personal-order-list-table .personal-order-list-item .cart-item .additional .additional-line .add-name,
.personal_area .personal-order-list-table .personal-order-list-item .cart-item .additional .additional-line .value {
  line-height: 14px;
  background-color: #ffffff;
  position: relative;
  z-index: 2;
}

.personal_area .personal-order-list-table .personal-order-list-item .cart-item .additional .additional-line:after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 4px;
  display: block;
  width: 100%;
  height: 2px;
  background-image: url('@/assets/icons/dots.png');
}

.personal_area .personal-order-list-table .personal-order-list-item .cart-item .product-name {
  font-weight: 500;
  text-decoration: underline;
}

.personal_area .personal-order-list-table .personal-order-list-item .cart-item .right-side {
  width: 75%;
}

.personal_area .personal-order-list-table .personal-order-list-item .cart-item .image {
  width: 76px;
  min-width: 76px;
  height: 50px;
  border-radius: 6px;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  margin-right: 10px;
}

.personal_area .personal-order-list-table .personal-order-list-item .cart-item .item-holder {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: justify !important;
  -webkit-justify-content: space-between !important;
  -ms-flex-pack: justify !important;
  justify-content: space-between !important;
}

.personal_area .personal-order-list-table .personal-order-list-item .cart-item .item-holder .item-info {
  width: 50%;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
}

.personal_area .personal-order-list-table .personal-order-list-item .cart-item .item-holder .option-box {
  width: 40%;
  position: relative;
  -webkit-box-pack: justify !important;
  -webkit-justify-content: space-between !important;
  -ms-flex-pack: justify !important;
  justify-content: space-between !important;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  margin-top: 0;
}

.personal_area .personal-order-list-table .personal-order-list-item .cart-item .item-holder .option-box:after {
  content: "";
  width: 1px;
  height: 100%;
  background-color: #c8cfd9;
  display: block;
  position: absolute;
  left: 50%;
  top: 0;
}

.personal_area .personal-order-list-table .personal-order-list-item .cart-item .item-holder .option-box .item {
  width: 45%;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
  -moz-flex-direction: column;
  -webkit-flex-direction: column;
  justify-content: center;
  -moz-justify-content: center;
  -webkit-justify-content: center;
}

.personal_area .personal-order-list-table .personal-order-list-item .cart-item .item-holder .option-box .item .value {
  font-weight: 700;
  font-size: 18px;
}

.personal_area .personal-order-list-table .personal-order-list-item .cart-item .item-holder .option-box .item .item-name {
  font-size: 14px;
  line-height: 1;
  opacity: 0.6;
}

.personal_area .personal-order-list-table .personal-order-list-item .panel-bordered {
  border-radius: 11px;
  -webkit-border-radius: 11px;
  -moz-border-radius: 11px;
}

.personal_area .personal-order-list-table .personal-order-list-item .personal-order-list-item-footer {
  padding: 0px 20px;
  font-size: 16px;
}

.personal_area .personal-order-list-table .personal-order-list-item .personal-order-list-item-footer .order-related-info .value {
  font-weight: 700;
}

.personal_area .personal-order-list-table .personal-order-list-item .personal-order-list-item-footer .order-related-info {
  margin-bottom: 0;
}

.personal_area .personal-order-list-table .personal-order-list-item .personal-order-list-item-footer .order-related-info ul {
  margin-bottom: 10px;
}

.personal_area .personal-order-list-table .personal-order-list-item .personal-order-list-item-footer .billing-info {
  padding: 20px;
}

.personal_area .personal-order-list-table .personal-order-list-item .personal-order-list-item-footer .billing-info li {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: justify !important;
  -webkit-justify-content: space-between !important;
  -ms-flex-pack: justify !important;
  justify-content: space-between !important;
  -webkit-align-items: flex-end;
  align-items: flex-end;
  margin-bottom: 10px;
  position: relative;
}

.personal_area .personal-order-list-table .personal-order-list-item .personal-order-list-item-footer .billing-info li.total {
  margin-bottom: 0;
  margin-top: 30px;
}

.personal_area .personal-order-list-table .personal-order-list-item .personal-order-list-item-footer .billing-info li.total .value {
  line-height: 1;
  font-size: 20px;
  font-weight: 700;
}

.personal_area .personal-order-list-table .personal-order-list-item .personal-order-list-item-footer .billing-info li.total .name {
  text-transform: uppercase;
  font-weight: 600;
}

.personal_area .personal-order-list-table .personal-order-list-item .personal-order-list-item-footer .billing-info li:after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 4px;
  display: block;
  width: 100%;
  height: 2px;
  background-image: url('@/assets/icons/dots-dark.png');
}

.personal_area .personal-order-list-table .personal-order-list-item .personal-order-list-item-footer .billing-info .name {
  padding-right: 5px;
}

.personal_area .personal-order-list-table .personal-order-list-item .personal-order-list-item-footer .billing-info .value {
  padding-left: 5px;
}

.personal_area .personal-order-list-table .personal-order-list-item .personal-order-list-item-footer .billing-info .name,
.personal_area .personal-order-list-table .personal-order-list-item .personal-order-list-item-footer .billing-info .value {
  line-height: 16px;
  background-color: #f5f5f5;
  position: relative;
  z-index: 2;
}

.personal_area .personal-order-list-table .personal-order-list-item .personal-order-list-item-footer .checkbox-group .default-checkbox {
  display: inline-block;
  margin-bottom: 0;
  margin-right: 30px;
}

.personal_area .personal-order-list-table .personal-order-list-item .personal-order-list-item-footer .checkbox-group .default-checkbox label {
  font-size: 16px;
}

.personal_area .personal-order-list-table .personal-order-list-item .personal-order-list-item-footer .checkbox-group .default-checkbox:last-child {
  margin-right: 0;
}

.personal_area .personal-order-list-table .personal-order-list-item .personal-order-list-item-footer .footer-holder {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  padding-bottom: 15px;
}

.personal_area .personal-order-list-table .personal-order-list-item .personal-order-list-item-footer .footer-holder .right-item-footer {
  border-radius: 11px;
  background-color: #f5f5f5;
  width: 40%;
}

.personal_area .personal-order-list-table .personal-order-list-item .personal-order-list-item-footer .footer-holder .left-item-footer {
  width: 60%;
  padding-right: 75px;
  padding-top: 15px;
}

.personal_area .personal-order-list-table .personal-order-list-item .personal-order-list-item-holder {
  border-top: 1px solid #c8cfd9;
  padding: 20px;
  font-size: 16px;
}

.personal_area .personal-order-list-table .personal-order-list-item .personal-order-list-item-bottom .lines {
  width: 50%;
  margin-top: 25px;
}

.personal_area .personal-order-list-table .personal-order-list-item .personal-order-list-item-bottom .line {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: justify !important;
  -webkit-justify-content: space-between !important;
  -ms-flex-pack: justify !important;
  justify-content: space-between !important;
  -webkit-align-items: flex-end;
  align-items: flex-end;
  margin-bottom: 15px;
  position: relative;
}

.personal_area .personal-order-list-table .personal-order-list-item .personal-order-list-item-bottom .line:after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 4px;
  display: block;
  width: 100%;
  height: 2px;
  background-image: url('@/assets/icons/dots-dark.png');
}

.personal_area .personal-order-list-table .personal-order-list-item .personal-order-list-item-bottom .name {
  padding-right: 5px;
}

.personal_area .personal-order-list-table .personal-order-list-item .personal-order-list-item-bottom .value {
  padding-left: 5px;
  font-weight: 700;
}

.personal_area .personal-order-list-table .personal-order-list-item .personal-order-list-item-bottom .name,
.personal_area .personal-order-list-table .personal-order-list-item .personal-order-list-item-bottom .value {
  line-height: 16px;
  background-color: #ffffff;
  position: relative;
  z-index: 2;
}

.personal_area .personal-order-list-table .personal-order-list-item .comment-curier-area .label-custom {
  opacity: 0.6;
  font-size: 14px;
}

.personal_area .personal-order-list-table .personal-order-list-item .comment-curier-area .text {
  font-size: 16px;
  line-height: 20px;
}

.personal_area .personal-order-list-table .personal-order-list-item .list-item-top {
  transition: all 0.2s cubic-bezier(0.165, 0.84, 0.44, 1);
  -webkit-transition: all 0.2s cubic-bezier(0.165, 0.84, 0.44, 1);
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  position: relative;
  padding: 15px;
}

.personal_area .personal-order-list-table .personal-order-list-item .list-item-top .date_status-body .date {
  opacity: 0.6;
  font-size: 14px;
  line-height: 1;
  display: block;
}

.personal_area .personal-order-list-table .personal-order-list-item .list-item-top .department-info .department-info-box {
  margin-top: 5px;
}

.personal_area .personal-order-list-table .personal-order-list-item .list-item-top .department-info {
  margin-top: 20px;
}

.personal_area .personal-order-list-table .personal-order-list-item .list-item-top .department-info .department-info-name {
  font-size: 14px;
  line-height: 1;
  opacity: 0.6;
}

.personal_area .personal-order-list-table .personal-order-list-item .list-item-top .status-bar {
  margin-top: 15px;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  white-space: nowrap;
  -webkit-align-items: center;
  align-items: center;
}

.personal_area .personal-order-list-table .personal-order-list-item .list-item-top .status-bar .status {
  line-height: 1;
  display: block;
  font-size: 20px;
}

.personal_area .personal-order-list-table .personal-order-list-item .list-item-top .price-box {
  text-align: center;
}

.personal_area .personal-order-list-table .personal-order-list-item .list-item-top .price-box .price-element {
  font-size: 30px;
}

.personal_area .personal-order-list-table .personal-order-list-item .list-item-top .date_status {
  position: relative;
  padding-left: 20px;
  width: 45%;
}

.personal_area .personal-order-list-table .personal-order-list-item .list-item-top .date_status .price-element {
  display: none;
}

.personal_area .personal-order-list-table .personal-order-list-item .list-item-top .date_status.order_canceled:before {
  background-color: #e31c25;
}

.personal_area .personal-order-list-table .personal-order-list-item .list-item-top .date_status.order_proccess:before {
  background-color: #fed70b;
}

.personal_area .personal-order-list-table .personal-order-list-item .list-item-top .date_status.order_new:before {
  background-color: #39a0f7;
}

.personal_area .personal-order-list-table .personal-order-list-item .list-item-top .date_status.order_success:before {
  background-color: #4ec275;
}

.personal_area .personal-order-list-table .personal-order-list-item .list-item-top .date_status:before {
  content: '';
  display: block;
  width: 3px;
  border-radius: 3px;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

.logged-in .logged-order-info .default-link {
  margin-top: 0;
}

.logged-in .logged-in-total .value {
  font-weight: 700;
}

.logged-in .logged-in-total .name {
  margin-right: 5px;
  display: inline-block;
  opacity: 0.6;
}

.logged-in .user-phone .text {
  color: #005BE5;
  text-decoration: underline;
  display: inline-block;
  margin-left: 5px;
}

.logged-in .user-phone {
  position: absolute;
  right: 0;
  bottom: 0;
}

.logged-in .logged-order-info {
  border-top: 1px solid #c8cfd9;
  padding-top: 10px;
  margin-bottom: 25px;
  margin-top: 10px;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
}

.logged-in {
  display: block;
  letter-spacing: normal;
  padding-top: 20px;
  padding-bottom: 20px;
  width: 100%;
  max-width: 1000px;
  margin: 40px auto 0;

}

.logged-in .logged-in-body {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  position: relative;
}

.logged-in .logged-in-body .avatar-info .bonus-panel span {
  display: inline-block;
  border: 1px solid #c8cfd9;
  padding: 0px 8px;
  line-height: 20px;
  text-transform: uppercase;
  font-size: 11px;
  border-radius: 4px;
}

.logged-in .logged-in-body .avatar-info .bonus-panel span.num {
  padding: 0;
  border: none;
  color: #279D11;
  font-weight: 700;
  margin-left: 10px;
  font-size: 13px;
}

.logged-in .logged-in-body .user-avatar {
  width: 46px;
  height: 46px;
  min-width: 46px;
  border-radius: 50%;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  justify-content: center;
  -moz-justify-content: center;
  -webkit-justify-content: center;
  background-color: #f7f7f7;
  margin-right: 15px;
  font-size: 24px;
  text-transform: uppercase;
  line-height: 1;
}

@media (max-width : 1199px) {

  /*.personal_area .personal-order-list-table .personal-order-list-item .comment-curier-area {*/
  /*  padding : 15px;*/
  /*}*/
  .personal_area .personal-order-list-table .personal-order-list-item .list-item-top .date_status {
    padding-left: 15px;
    width: 55%;
  }

  .personal_area .personal-order-list-table .personal-order-list-item .list-item-top .price-box .price-element {
    font-size: 24px;
  }

  .department-map {
    padding: 15px;
  }

  .personal_area .personal-order-list-table .personal-order-list-item .personal-order-list-item-footer {
    padding: 0px 15px;
  }

  .personal_area .personal-order-list-table .personal-order-list-item .personal-order-list-item-holder {
    padding: 15px;
  }

  .personal_area .personal-order-list-table .personal-order-list-item .personal-order-list-item-footer .footer-holder .right-item-footer {
    width: 50%;
  }

  .personal_area .personal-order-list-table .personal-order-list-item .personal-order-list-item-footer .footer-holder .left-item-footer {
    padding-right: 15px;
    width: 50%;
  }

  .logged-in,
  .personal_area .personal-area-body {
    max-width: 700px;
  }
}

@media (max-width : 767px) {
  .logged-in {
    padding-top: 15px;
    padding-bottom: 15px;
  }

  .personal_area .personal-order-list-table .personal-order-list-item .personal-order-list-item-footer .footer-holder .left-item-footer {
    padding-right: 0;
  }

  .personal_area .personal-order-list-table .personal-order-list-item .personal-order-list-item-footer .billing-info li.total {
    margin-top: 15px;
  }

  .personal_area .personal-order-list-table .personal-order-list-item .personal-order-list-item-footer .billing-info li {
    margin-bottom: 6px;
  }

  .personal_area .personal-order-list-table .personal-order-list-item .comment-curier-area .text {
    font-size: 14px;
  }

  .order-related-info li {
    margin-bottom: 0px;
  }

  .logged-in .default-checkbox label {
    font-size: 14px;
  }

  .logged-in .logged-in-body .user-avatar {
    margin-right: 10px;
  }

  .personal_area .personal-order-list-table .personal-order-list-item .list-item-top .date_status {
    padding-left: 10px;
    width: 100%;
  }

  .personal_area .personal-order-list-table .personal-order-list-item .show-in-map {
    top: 10px;
    right: 13px;
  }

  .personal_area .personal-order-list-table .personal-order-list-item .list-item-top .department-info .department-info-name {
    font-size: 12px;
  }

  .personal_area .personal-order-list-table .personal-order-list-item .list-item-top .date_status-body .date {
    font-size: 11px;
  }

  .personal_area .personal-order-list-table .personal-order-list-item .list-item-top .date_status[data-v-0e3664d0] {

    width: 100%;
  }

  .logged-in-total {
    font-size: 12px;
  }

  .logged-in .logged-order-info .default-link {
    font-size: 12px;
  }

  .manager-personal-area .bottom-nav .default-btn {
    margin: auto;
    line-height: 40px;
    padding: 0px 35px;

  }

  .manager-personal-area .bottom-nav .button-holder:first-child {
    border-right: 1px solid #c8cfd9;
  }

  .manager-personal-area .bottom-nav .button-holder {
    padding: 10px 0;
    position: relative;
    margin: 0;
    width: 50%;
    text-align: center;
  }

  .personal_area {
    padding-bottom: 60px;
  }

  .manager-personal-area .bottom-nav {
    padding: 0;
    position: fixed;
    width: 100%;
    bottom: 0;
    left: 0;
    z-index: 11111;

  }

  .personal_area .personal-order-list-table .personal-order-list-item .personal-order-list-item-footer .footer-holder .left-item-footer {
    padding-top: 0;
  }

  .logged-in {
    border: none;
    background: #f7f7f7;
  }

  .logged-in,
  .personal_area .personal-area-body {
    margin: 0;
  }

  .container-wrapper.manager-personal-area {
    background: #fff;
    padding: 15px;
  }

  .personal_area .personal-order-list-table .personal-order-list-item .personal-order-list-item-holder {
    font-size: 14px;
  }

  .logged-in .user-phone {
    font-size: 12px;
  }

  .personal_area .personal-order-list-table .personal-order-list-item .personal-order-list-item-footer .billing-info {
    padding: 20px 15px;
  }

  .personal_area .personal-order-list-table .personal-order-list-item .personal-order-list-item-footer .footer-holder .left-item-footer,
  .personal_area .personal-order-list-table .personal-order-list-item .personal-order-list-item-footer .footer-holder .right-item-footer {
    width: 100%;
  }

  .personal_area .personal-order-list-table .personal-order-list-item .personal-order-list-item-footer .footer-holder {
    padding: 0;
    border: none;
    flex-direction: column;
    -webkit-flex-direction: column;
  }

  .personal_area .personal-order-list-table .personal-order-list-item .personal-order-list-item-footer {
    border-top: 1px solid #c8cfd9;
    font-size: 14px;
    padding-top: 20px;
  }

  .personal_area .personal-order-list-table .personal-order-list-item .personal-order-list-item-bottom .lines {
    width: 100%;
    margin-top: 20px;
  }

  .personal_area .personal-order-list-table .personal-order-list-item .personal-order-list-item-bottom .line {
    margin-bottom: 10px;

  }

  .personal_area .personal-order-list-table .personal-order-list-item .cart-item {
    border: none;
    background-color: #f7f7f7;
  }

  .personal_area .personal-order-list-table .personal-order-list-item .cart-item .additional .additional-line {
    margin-bottom: 7px;
  }

  .personal_area .personal-order-list-table .personal-order-list-item .cart-item .additional {
    margin-top: 10px;
    background: #fff;
    border-radius: 6px;
    padding: 10px 10px 5px;
  }

  .personal_area .personal-order-list-table .personal-order-list-item .cart-item .item-holder .option-box:after {
    display: none;
  }

  .personal_area .personal-order-list-table .personal-order-list-item .cart-item .item-holder .option-box .item .value {
    font-size: 14px;
  }

  .personal_area .personal-order-list-table .personal-order-list-item .cart-item .item-holder .option-box .item {
    width: 100%;
    flex-direction: row;
    -moz-flex-direction: row;
    -webkit-flex-direction: row;
    text-align: left !important;
    justify-content: space-between;
    -moz-justify-content: space-between;
    -webkit-justify-content: space-between;
  }

  .personal_area .personal-order-list-table .personal-order-list-item .cart-item .item-holder {
    display: block;
  }

  .personal_area .personal-order-list-table .personal-order-list-item .cart-item .item-holder .item-info {
    width: 100%;
  }

  .personal_area .personal-order-list-table .personal-order-list-item .cart-item .item-holder .option-box {
    width: 100%;
    padding-left: 85px;
    margin-top: 10px;
    display: block;
  }

  .personal_area .personal-order-list-table .personal-order-list-item .list-item-top .status-bar .status {
    font-size: 16px;
  }

  .personal_area .personal-order-list-table .personal-order-list-item .list-item-top .department-info {
    margin-top: 15px;
  }

  .personal_area .personal-order-list-table .personal-order-list-item .show-in-map {
    left: auto;
    top: 15px;
    right: 15px;
  }

  .personal_area .personal-order-list-table .personal-order-list-item .list-item-top .price-box {
    display: none;
  }

  .personal_area .personal-order-list-table .personal-order-list-item .list-item-top .date_status .price-element {
    display: block;
    font-size: 20px;
    margin-top: 5px;
  }

  .frame-modal-wrapper.order-address-select {
    transform: none;
    width: 100%;
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1111;
    height: 100%;
  }

  .frame-modal-wrapper.order-address-select .search-input img {
    top: 6px;
  }

  .frame-modal-wrapper.quick-cart .frame-modal-list {
    height: 290px;
  }

  .frame-modal-wrapper.order-address-select {
    top: 0;
    background: rgba(0, 0, 0, 0.5);
  }

  .frame-modal-wrapper.order-address-select .address-list {
    height: 375px;
  }

  .frame-modal-wrapper.order-address-select .address-list li {
    border-bottom: 1px solid rgba(0, 0, 0, 0.09999999999999998);
    margin: 0;
  }

  .frame-modal-wrapper.order-address-select .address-list li a {
    height: 50px;
  }

  .frame-modal-wrapper.order-address-select .address-list li:last-child {
    border: none;
  }

  .frame-modal-wrapper.order-address-select .modal-wrapper-holder {
    position: absolute;
    width: 100%;
    left: 0;
    bottom: 0;
    border-radius: 16px 16px 0px 0px;
  }

  .frame-modal-wrapper.order-address-select .frame-modal-body {
    padding: 15px;
  }
}
</style>